module.exports = __webpack_public_path__ + "assets/images/cubo_0f7c7b3ee2e74fa4815de2f5408aae51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cubo/cubo.png
// module id = 196
// module chunks = 0